exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2R0JJN6xqwYgCoYA-5Tny1{display:block}@media (max-width:30em){._2R0JJN6xqwYgCoYA-5Tny1{margin-top:20px}}@media (min-width:30em){._2R0JJN6xqwYgCoYA-5Tny1{position:absolute;left:50%;top:-55px;transform:translateX(-50%);border-radius:1000px;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.2)}._2R0JJN6xqwYgCoYA-5Tny1+h1{margin-top:30px}}._3qpr9dNYu1uw8t-Pb0cuH_{width:100px;height:100px;overflow:hidden;background-position:50%;background-size:cover;margin-right:auto;margin-left:auto;border-radius:100px;background-color:#e0e2e7}", ""]);

// exports
exports.locals = {
	"wrapper": "_2R0JJN6xqwYgCoYA-5Tny1",
	"image": "_3qpr9dNYu1uw8t-Pb0cuH_"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/user-image/user-image.css
// module id = 291
// module chunks = 0 1 2